import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_362: DocMigration = {
  maxSchemaVersion: "0.0.362",
  description: "Rename prop attributes' floorPlanPrettyName to floorPlanTag & planOffset to floorPlanTagOffset",
  apply(json: any) {
    for (const id in json.propInstances) {
      remapPropTypes(json.propInstances[id]);
    }

    for (const id in json.settings) {
      const settings = json.settings[id];

      if (settings.type === "EXTERIOR_PROP_SETTINGS") {
        for (const settingsKey in settings.propTypes) {
          remapPropTypes(settings.propTypes[settingsKey]);
        }
      }

      if (settings.type === "INTERIOR_PROP_SETTINGS") {
        for (const settingsKey in settings.propTypes) {
          remapPropTypes(settings.propTypes[settingsKey]);
        }
      }
    }

    return json;
  },
};

export default migration_0_0_362;

function remapPropTypes(propTypes: Record<string, any>) {
  if (propTypes.floorPlanPrettyName !== undefined) {
    propTypes.floorPlanTag = propTypes.floorPlanPrettyName;
  }

  delete propTypes.floorPlanPrettyName;

  if (propTypes.planOffset !== undefined) {
    propTypes.floorPlanTagOffsetX = propTypes.planOffset;
  }

  delete propTypes.planOffset;
}
